import request from '@/utils/http-util'
import { baseUrl } from '/env'

export function getByLocationApi(params) {
    return request({
        url: baseUrl+'/weather/getByLocation',
        method: 'get',
        params
    })
}